<template>
    <div>
      <div v-if="sampleContent">
        Sample content provided
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        No sample content provided
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewSampleContent',
    props: [
        'sampleContent',
    ],
    computed: {

    }
}
</script>

<style lang="scss" scoped>

</style>